export const environment = {
  production: true,
  baseApi: "https://server-shopping-romd.onrender.com/api/auth"  //'https://server-shopping-romd.onrender.com/api/auth' // http://localhost:5000/api/auth
};
